/** Search excerpts are display text, never executable source markup. */
export function searchExcerptText(value:string,extracted=false):string {
 const stripped=value.replace(/<(script|style)\b[^>]*>[\s\S]*?<\/\1\s*>/gi,' ')
  .replace(/<!--[\s\S]*?-->/g,' ').replace(/<\/?[a-z][a-z0-9-]*(?:\s[^<>]*)?\/?>/gi,' ');
 const decoder=document.createElement('textarea');decoder.innerHTML=stripped;
 const clean=decoder.value.replace(/<\/?[a-z][a-z0-9-]*(?:\s[^<>]*)?\/?>/gi,' ');
 return (extracted?clean.replace(/^ {0,3}#{1,6}[\t ]+/gm,'').replace(/<\/[a-z0-9-]*\s*$/i,' '):clean).replace(/\s+/g,' ').trim();
}
export function SearchExcerpt({text,query,extracted=false}:{text:string;query:string;extracted?:boolean}){
 const clean=searchExcerptText(text,extracted),terms=[...new Set(query.trim().toLocaleLowerCase('en-GB').split(/\s+/).filter(Boolean))].slice(0,20);
 if(!terms.length)return <>{clean}</>;
 const escaped=terms.map(term=>term.replace(/[.*+?^${}()|[\]\\]/g,'\\$&'));
 return <>{clean.split(new RegExp('('+escaped.join('|')+')','gi')).map((part,index)=>terms.includes(part.toLocaleLowerCase('en-GB'))?<mark key={index}>{part}</mark>:part)}</>;
}
